import types from '../../mutation-types';

const isNewer = (a, b) =>
  a.created_at !== b.created_at ? a.created_at > b.created_at : a.id > b.id;

export const mutations = {
  [types.SET_NOTIFICATIONS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.CLEAR_NOTIFICATIONS]: $state => {
    $state.records = {};
    $state.uiFlags.isAllNotificationsLoaded = false;
  },
  [types.SET_NOTIFICATIONS_META]: ($state, data) => {
    const {
      count,
      current_page: currentPage,
      unread_count: unreadCount,
    } = data;

    $state.meta = { ...$state.meta, count, currentPage, unreadCount };
  },
  [types.SET_NOTIFICATIONS_UNREAD_COUNT]: ($state, count) => {
    $state.meta.unreadCount = count < 0 ? 0 : count;
  },
  [types.SET_NOTIFICATIONS]: ($state, data) => {
    data.forEach(notification => {
      // Conversation (and others): one per primary_actor (type + id). Task: ids only
      // unique per type, and a card has one notification per notification_type.
      const isTask = notification.primary_actor_type === 'Task';
      const existingNotification = Object.values($state.records).find(
        record =>
          record.id !== notification.id &&
          record.primary_actor_id === notification.primary_actor_id &&
          record.primary_actor_type === notification.primary_actor_type &&
          (!isTask ||
            record.notification_type === notification.notification_type)
      );
      // Same notification received multiple times (e.g. on reconnect): the old one is
      // deleted and the new one added. For Task never let an older record replace a newer one.
      if (existingNotification) {
        const isOlder = isTask && isNewer(existingNotification, notification);
        if (isOlder) return;
        delete $state.records[existingNotification.id];
      }

      $state.records[notification.id] = {
        ...($state.records[notification.id] || {}),
        ...notification,
      };
    });
  },
  [types.READ_NOTIFICATION]: ($state, { id, read_at }) => {
    $state.records[id].read_at = read_at;
  },
  [types.UPDATE_ALL_NOTIFICATIONS]: $state => {
    Object.values($state.records).forEach(item => {
      $state.records[item.id].read_at = true;
    });
  },

  [types.ADD_NOTIFICATION]($state, data) {
    const {
      notification,
      unread_count: unreadCount,
      count,
      unread_count_with_tasks: unreadCountWithTasks,
      count_with_tasks: countWithTasks,
    } = data;

    $state.records[notification.id] = {
      ...($state.records[notification.id] || {}),
      ...notification,
    };
    $state.meta.unreadCount = unreadCountWithTasks ?? unreadCount;
    $state.meta.count = countWithTasks ?? count;
  },
  [types.UPDATE_NOTIFICATION]($state, data) {
    const {
      notification,
      unread_count: unreadCount,
      count,
      unread_count_with_tasks: unreadCountWithTasks,
      count_with_tasks: countWithTasks,
    } = data;
    $state.records[notification.id] = {
      ...($state.records[notification.id] || {}),
      ...notification,
    };
    $state.meta.unreadCount = unreadCountWithTasks ?? unreadCount;
    $state.meta.count = countWithTasks ?? count;
  },
  [types.DELETE_NOTIFICATION]($state, data) {
    const {
      notification,
      unread_count: unreadCount,
      count,
      unread_count_with_tasks: unreadCountWithTasks,
      count_with_tasks: countWithTasks,
    } = data;
    delete $state.records[notification.id];
    $state.meta.unreadCount = unreadCountWithTasks ?? unreadCount;
    $state.meta.count = countWithTasks ?? count;
  },
  [types.SET_ALL_NOTIFICATIONS_LOADED]: $state => {
    $state.uiFlags.isAllNotificationsLoaded = true;
  },

  [types.DELETE_READ_NOTIFICATIONS]: $state => {
    Object.values($state.records).forEach(item => {
      if (item.read_at) {
        delete $state.records[item.id];
      }
    });
  },
  [types.DELETE_ALL_NOTIFICATIONS]: $state => {
    $state.records = {};
  },

  [types.SNOOZE_NOTIFICATION]: ($state, { id, snoozed_until }) => {
    $state.records[id].snoozed_until = snoozed_until;
  },

  [types.SET_NOTIFICATION_FILTERS]: ($state, filters) => {
    $state.notificationFilters = filters;
  },
  [types.UPDATE_NOTIFICATION_FILTERS]: ($state, filters) => {
    $state.notificationFilters = {
      ...$state.notificationFilters,
      ...filters,
    };
  },
};
